import {Image as AntImage, ImageProps, Skeleton} from 'antd-mobile';
import React from 'react';

export default function Image(props: ImageProps) {
  return (
    <AntImage
      {...props}
      placeholder={
        <Skeleton
          animated
          style={{
            '--height': '100%',
            '--width': '100%',
          }}
        />
      }
    />
  );
}
